import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'
import { make } from 'vuex-pathify'

Vue.use(Vuex)

const state = {
  calendar: {},
  overlay: {},
}

const mutations = make.mutations(state)

const store = new Vuex.Store({
  plugins: [pathify.plugin],
  state,
  mutations,
})

Vue.config.productionTip = false

export default store
